import axios from 'axios'
import * as jobActions from './store/actions'

/**
 * get job list
 *
 * @param credentials
 * @returns {function(*)}
 */
export function getSelectedList(jobIds) {
  return dispatch => (
    new Promise((resolve, reject) => {
      axios.post('/api/houjin/jobs/selected', jobIds)
        .then(res => {
          dispatch(jobActions.getSelectedList(res.data.data, jobIds))
          return resolve()
        })
        .catch((err) => {
          return reject(err);
        })
    })
  )
}

/**
 * get job detail
 *
 * @param credentials
 * @returns {function(*)}
 */
export function getDetail(id) {
  return dispatch => (
    new Promise((resolve, reject) => {
      axios.get('staff/job/' + id)
        .then(res => {
          dispatch(jobActions.getDetail(res.data))
          return resolve()
        })
        .catch((err) => {
          return reject(err);
        })
    })
  )
}
export function updateStateJobs(params) {
	return dispatch => (
		new Promise((resolve, reject) => {
			dispatch(jobActions.updateStateJobs(params))
			return resolve()
		})
	)
}
export function updateBulkCopyCheckboxState(params) {
	return dispatch => (
		new Promise((resolve, reject) => {
			dispatch(jobActions.updateBulkCopyCheckboxState(params))
			return resolve()
		})
	)
}
export function initSelectedList(params) {
	return dispatch => (
		new Promise((resolve, reject) => {
			dispatch(jobActions.initSelectedList(params))
			return resolve()
		})
	)
}

export function initSelectedIdList(params) {
	return dispatch => (
		new Promise((resolve, reject) => {
			dispatch(jobActions.initSelectedIdList(params))
			return resolve()
		})
	)
}
